// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.async.AsyncResponse
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { RemoteAbInitioErrorException } from "abweb/dto/exception/RemoteAbInitioErrorException";
import { AsyncMessage } from "abweb/dto/generated/async/AsyncMessage";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class AsyncResponseBase {
  /** Do NOT invoke directly, instead use strongly typed createAsyncResponseBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawada.AsyncResponse";
  }
  initFromJson(json, deserializeContext) {
    this.initAsyncResponse(json.canceled != null ? json.canceled : null, json.done != null ? json.done : null, TSOGUtils.decodeObject(json.error, RemoteAbInitioErrorException, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "error")), json.messages != null ? TSOGUtils.decodeObjectArray(json.messages, AsyncMessage, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "messages")) : null, json.response != null ? json.response : null, json.taskId != null ? json.taskId : null);
  }
  initAsyncResponse(canceled, done, error, messages, response, taskId) {
    this._canceled = canceled;
    this._done = done;
    this._error = error;
    this._messages = messages;
    this._response = response;
    this._taskId = taskId;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["canceled"] = this._canceled;
    retVal["done"] = this._done;
    if (this._error != null) {
      retVal["error"] = TSOGUtils.toTSOGNativeObject(this._error, serializeContext);
    }
    retVal["messages"] = TSOGUtils.toTSOGArray(this._messages, serializeContext);
    if (this._response != null) {
      retVal["response"] = this._response;
    }
    retVal["taskId"] = this._taskId;
    return retVal;
  }
  get canceled() {
    return this._canceled;
  }
  set canceled(value) {
    this._canceled = value;
  }
  get done() {
    return this._done;
  }
  set done(value) {
    this._done = value;
  }
  get error() {
    return this._error;
  }
  set error(value) {
    this._error = value;
  }
  get messages() {
    return this._messages;
  }
  set messages(value) {
    this._messages = value;
  }
  get response() {
    return this._response;
  }
  set response(value) {
    this._response = value;
  }
  get taskId() {
    return this._taskId;
  }
  set taskId(value) {
    this._taskId = value;
  }
}
//# sourceMappingURL=AsyncResponseBase.js.map
